<template>
  <div>
    <basic-container>
      <div style="height: 20px"></div>
      <el-form :inline="true" ref="form" :model="form">
        <el-row>
          <el-col span="6">
            <el-form-item label="项目名称" style="width: 100%; display: flex">
              <el-select
                style="width: 100%; flex: 1"
                v-model="form.projectId"
                placeholder="项目"
                size="small"
              >
                <el-option
                  v-for="(item, index) in projectIdList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="部门名称" style="width: 100%; display: flex">
              <el-select
                style="width: 100%; flex: 1"
                v-model="form.deptId"
                placeholder="部门"
                size="small"
              >
                <el-option :value="form.deptId" show-all-levels :label="form.deptName">
                  <el-tree
                    v-if="form.projectId"
                    node-key="id"
                    :data="treeFormDeptData"
                    :props="treeDeptProps"
                    :load="deptLazyLoadTree"
                    lazy
                    @node-click="deptNodeTreeClick"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item>
              <el-button type="primary" @click="onSubmit">搜索</el-button>
              <el-button type="primary" @click="searchReset">清空</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <WebReport ref="WebReport" :url="url" :params="params"/>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import urlSettings from '@/config/url-settings';
import WebReport from '@/components/web-report';
import {getProjectList} from "@/api/crmedical/report/questionnaire.js";
import {tree} from "@/api/crmedical/device/devicetype";
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  childNode,
  userList,
  copyDevice,
  getTableStructure,
  submitFormData,
  deviceExport,
  getProjectDept
} from "@/api/crmedical/device/device";
export default {
  components: {
    WebReport,
  },
  data() {
    return {
      treeFormDeptData: [],
      treeDeptProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      userList: [],

      url: '',
      form: {
        projectId: "",
        deptId: "",
      },
      projectList: [],
      oldOptions: [],
      params: {
        reportlet:urlSettings.VUE_APP_ENVIRONMENT +  '/deptDeviceStatusReport.cpt',
        //  reportlet: 'oweSummary.cpt',
      },
      dic: [],
    };
  },
  watch:{
    'form.projectId': function (val,oldVal) {
      if(val){
        getProjectDept({projectId: val}).then(({data}) => {
          this.form.deptId = "";
          this.form.deptName = "";
          this.treeFormDeptData = data;
        });
      }
    },
  },
  methods: {
    deptLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
        childNode({parentId: id}).then(({data}) => {
          resolve(data);
        });
      }
    },
    deptNodeTreeClick(node) {
      let nodeId = node.value;
      let nodeTitle = node.title;
      this.form.deptName = nodeTitle;
      this.form.deptId = nodeId;
      this.form.chargeManId = '';
      userList({deptId: nodeId}).then(({data}) => {
        console.log('data userList==>',data);
        data.forEach(item=>{
          item.value = item.id;
          item.label = item.realNameAndPhone
        })
        this.userList = data;
      })
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.params.projectId = this.form.projectId;
          this.params.deptId = this.form.deptId;

          setTimeout(() => {
            this.$refs.WebReport.regroupUrl();
          }, 0);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    searchReset(){
      if (this.projectIdList.length > 0) {
        this.form.projectId = this.projectIdList[0].id;
      }
      this.form.deptId = "";
      this.form.deptName = "";
      this.onSubmit();
    },

    initPropertyList() {
      getProjectList({}).then((res) => {
        this.projectIdList = res.data;
        if (this.projectIdList.length > 0) {
          this.form.projectId = this.projectIdList[0].id;
        }

        var reportUrl = urlSettings.BASE_REPORT_URL;
        this.url = reportUrl.split('?')[0];
        //this.url = 'http://localhost:8075/WebReport/ReportServer?reportlet=deptDeviceStatusReport.cpt';

        this.params.projectId = `${this.projectIdList[0].id}`;

      setTimeout(() => {
          this.$refs.WebReport.regroupUrl();
        }, 0);
      });
    },
  },

  created() {
    this.initPropertyList();
  },
};
</script>

<style></style>
